<template>
  <div class="form" style="text-align:left;">
    <div class="title is-4">{{ title }}</div>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Produktionszeit">
          <multiselect id="minProductiontime" v-model="selectedMinProductiontime" placeholder="Produktionszeit auswählen"
            :options="minProductiontime" label="label" track-by="value":multiple="false" :close-on-select="true"></multiselect>
        </b-field>
        <b-field label="Spieltyp">
          <multiselect v-model="item.gametype" :show-labels="false" placeholder="Spieltyp auswählen" :options="gameType"
            :multiple="false" :close-on-select="true"></multiselect>
        </b-field>
        <b-field label="Weitere Felder"> </b-field>
        <b-field v-for="(field, index) in item"
          v-if="index != 'id' && index != 'gametype' && index != 'minProductiontime'" :message="index">
          <b-input maxlength="255" v-if="index == 'name'" size="is-small" v-model="item[index]"></b-input>
          <!-- <b-numberinput step="0.001" v-if="index != 'name'"  size="is-small" v-model="item[index]"></b-numberinput> -->
          <b-input pattern="[+]?[0-9]*\.?[0-9]+" v-if="index != 'name'" size="is-small" v-model="item[index]"></b-input>
        </b-field>
      </div>
      <div class="column">

      </div>
    </div>

    <div class="columns">
      <div class="column">
        <b-button type="is-primary" v-on:click="save()" :disabled="loading">Speichern</b-button>
      </div>
    </div>

  </div>
</template>


<script>
// @ is an alias to /src

import Vue from 'vue'
import Multiselect from 'vue-multiselect'

const axios = require('axios');


export default {
  name: "SingleExtraCharge",
  components: {
    Multiselect,
  },
  data() {
    return {
      title: "Neuen Aufschlagsatzstaffel anlegen",
      item: {},
      loading: true,
      gameType: ["Standard", "Klassiker"],
      minProductiontime: [
      { label: "Unter 10 AT", value: 0 },
      { label: "Ab 10 AT", value: 10 }
    ]
      //  item: { 'id': 22, 'name': 'Beidseitig individuelles Kartenset', 'spielart': 'Kartenspiel', 'date': '2016-10-15 13:43:27' },
    }
  },
  computed: {
    selectedMinProductiontime: {
      get() {
        // Sucht in den Optionen nach dem Objekt, dessen value mit item.minProductiontime übereinstimmt
        return this.minProductiontime.find(
          option => option.value === this.item.minProductiontime
        ) || null;
      },
      set(selected) {
        // Speichert im Model nur den reduzierten Wert
        this.item.minProductiontime = selected ? selected.value : null;
      }
    }
  },
  watch: {

  },
  mounted: function () {
    console.log("FORM " + this.$route.params.id);
    if (this.$route.params.id) {
      this.title = "Aufschlagsatzstaffel bearbeiten";
      //Get-Game
      var _this = this;
      axios.get('/api/extracharge/' + this.$route.params.id, {
        withCredentials: true,
      })
        .then(function (response) {
          console.log(response.data);
          _this.item = response.data;
          _this.loading = false;

        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
        });
    } else {
      var newExtraCharge = _.cloneDeep(emptyExtraCharge);
      this.item = newExtraCharge;
      this.loading = false;
    }

  },
  methods: {
    save: function () {
      console.log("this.item")
      console.log(this.item)
      if (this.item.name && this.item.minProductiontime != null && this.item.gametype) {

        //Set-Package
        var _this = this;
        var url = '/api/extracharge';


        console.log("SAVE");
        console.log(url);
        console.log(this.item);

        axios.post(url, this.item, {
          headers: {
            'Content-Type': 'application/json',
          },
          withCredentials: true,
        })
          .then(function (response) {
            console.log(response.data);
            _this.$router.push({ name: 'extracharges' })
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
            // always executed
          });

      } else {
        console.log("Alle Felder ausfüllen");
        this.$buefy.dialog.alert({
          title: 'Fehler',
          message: 'Bitte füllen Sie alle Felder aus.',
          type: 'is-danger',
          hasIcon: true,
          icon: 'alert-circle',
          iconPack: 'mdi'
        });

      }

    }
  }
};

const emptyExtraCharge =
{
  name: "",
  hk100: 0,
  hk200: 0,
  hk300: 0,
  hk400: 0,
  hk500: 0,
  hk600: 0,
  hk700: 0,
  hk800: 0,
  hk900: 0,
  hk1000: 0,
  hk1200: 0,
  hk1400: 0,
  hk1600: 0,
  hk1800: 0,
  hk2000: 0,
  hk2500: 0,
  hk3000: 0,
  hk4000: 0,
  hk5000: 0,
  hk7500: 0,
  hk10000: 0,
  hk15000: 0,
  hk20000: 0,
  hk30000: 0,
  hk50000: 0,
  hk100000: 0
}
  ;

</script>
